import { useSelector } from 'react-redux';

import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import {
  selectNbProducts,
  selectNbProductsPerPage,
} from '../selectors/nbProducts';

export const useNbProducts = (): number | undefined =>
  useSelector<SpartacuxProductDiscoveryDomainState, number | undefined>(
    selectNbProducts,
  );

export const useNbProductsPerPage = (): number =>
  useSelector<SpartacuxProductDiscoveryDomainState, number>(
    selectNbProductsPerPage,
  );
